'use client'

import { ProductCard } from '@/components/common/product-card'
import { ProductCardSkeleton } from '@/components/common/product-card/product-item-skeleton'
import { useProductListByIds } from '@/hooks/react-query/products/use-product'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const COMBO_PRODUCT_IDS = [
  '6ad098ca7a5c3b2b5b3e1303',
  '6ad09f4011491f5d3f47a7e2',
]

export const TheMartianCombo = () => {
  const t = useTranslations('the_martian_hardcode.combo')
  const { data: products, isLoading } = useProductListByIds(COMBO_PRODUCT_IDS)

  console.log('products', products)

  if (!isLoading && !products?.length) return null

  return (
    <section className='grid gap-6 bg-neutral-50 px-5 py-10 lg:grid-cols-[953fr_907fr] lg:gap-0 lg:p-0 lg:pl-15'>
      {/* Mobile: ảnh hộp quà lên trên dạng card bo góc, desktop: tràn hết chiều cao bên phải */}
      <div className='relative aspect-[335/234] overflow-hidden rounded-2xl lg:order-2 lg:aspect-auto lg:rounded-none'>
        {/* Figma có ảnh crop riêng cho mobile (ngang) và desktop (dọc) */}
        <picture>
          <source
            media='(min-width: 1024px)'
            srcSet={ImageHelper.getImageUrlCdn(
              '/image/2026/10/19/tm_combo_box_v2.jpg'
            )}
          />
          <Image
            src={ImageHelper.getImageUrlCdn(
              '/image/2026/10/19/tm_combo_box_m_v2.jpg'
            )}
            alt={t('image_alt')}
            fill
            sizes='(min-width: 1024px) 47vw, 90vw'
            className='object-cover'
          />
        </picture>
      </div>

      <div className='grid content-start gap-6 lg:gap-10 lg:py-15 lg:pr-10'>
        <div className='grid gap-2'>
          <h2 className='font-criteria text-2xl font-bold uppercase italic leading-[1.25] text-neutral-800 lg:text-[32px] 2xl:text-[44px]'>
            {t.rich('title', {
              hl: (chunks) => <span className='text-[#F56A24]'>{chunks}</span>,
              br: () => <br className='max-lg:hidden' />,
            })}
          </h2>
          <p className='text-base leading-6 text-neutral-800 lg:text-lg lg:leading-[26px]'>
            {t.rich('description', {
              b: (chunks) => <strong className='font-bold'>{chunks}</strong>,
            })}
          </p>
        </div>

        <div className='grid grid-cols-2 gap-4 lg:gap-10 2xl:max-w-[906px]'>
          {isLoading
            ? COMBO_PRODUCT_IDS.map((id) => <ProductCardSkeleton key={id} />)
            : products?.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  gaTrackingValue='the-martian__combo'
                />
              ))}
        </div>
      </div>
    </section>
  )
}
